import React from "react";
import { UserModel } from "../../types/user";

export const MeContext = React.createContext<{
    me: UserModel | null;
    setMe: (user: UserModel | null) => void;
    setLogged?: (logged: boolean) => void;
    // true enquanto o /user/me pós-mount ainda não resolveu — RequirePermission
    // espera isso zerar antes de decidir, senão uma sessão com permissions
    // ainda não atualizadas (localStorage antigo) é redirecionada por engano.
    meLoading?: boolean;
}>({
    me: null,
    setMe: () => {},
    meLoading: false,
});
